// extracted by mini-css-extract-plugin
module.exports = {"container":"EditorContainer__container___dXop2","header":"EditorContainer__header___2ht4-","contentWrapper":"EditorContainer__contentWrapper___EJYoS"};